/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/TargetTreatment/Content",
  onChange,
  isValid,
  isInvalid
  
}) {
let targetTreatmentCardsValueData = fromData.useDataFormat({ viewPath,
context: 'target_treatment_cards',
format: fromHelpers.getTreatmentCards,
})
let moveResourcesTargetTreatmentCardIdValueData = fromData.useDataValue({ viewPath,
context: 'move_resources',
path: 'target_treatment_card_id',
})
let moveResourcesTargetTreatmentCardIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'move_resources',
path: 'target_treatment_card_id',
validate: fromValidate.text,
required: true,
})
let moveResourcesTargetTreatmentCardIdChangeData = fromData.useDataChange({ viewPath,
context: 'move_resources',
path: 'target_treatment_card_id',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 allowEmptyChoice={false}
 marginTop={0}
 flexGrow={0}
 data="target_treatment_cards"
 format="helpers.js getTreatmentCards"
 from={targetTreatmentCardsValueData}
 data="move_resources.target_treatment_card_id"
 value={moveResourcesTargetTreatmentCardIdValueData}
 onChange={moveResourcesTargetTreatmentCardIdChangeData}
 required={true}
 validate="/Data/validate.js text"
 valid={moveResourcesTargetTreatmentCardIdIsValidData}
 invalid={!moveResourcesTargetTreatmentCardIdIsValidData}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Move to treatment"
/>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}